<template>
  <div class="lecturer" :class="{ isIosx: isIosx, noAppNav: !isToken }">
    <van-sticky>
      <div class="lecturerNav" :class="{ isShowTitle: isTitle }">
        <img
          class="navLeft"
          @click="prev()"
          src="./../../assets/school/backh.png"
        />
        <span class="navTitle" v-if="isTitle">{{ data.name }}</span>
        <img
          v-if="isToken"
          class="navRight"
          src="./../../assets/school/sfh.png"
          @click="share()"
        />
      </div>
    </van-sticky>
    <div class="lecturerContent">
      <div class="lecturerTop">
        <img
          v-if="data.head_pic"
          :src="data.head_pic"
          @click="imagePreview(data.head_pic)"
        />
        <img v-else src="./../../assets/school/defaultAvatar.png" />
        <h3>{{ data.name }}</h3>
        <p>{{ data.desc }}</p>
        <span v-if="data.is_fans && isToken" @click="cancelConcern()"
          >已关注</span
        >
        <span v-if="!data.is_fans && isToken" @click="concern()">+ 关注</span>
      </div>
      <div class="lecturerMid">
        <h3>
          <span>精品课程({{ total }})</span>
          <span @click="changeShowType()">
            <img src="./../../assets/school/morerow.png" v-if="showType" />
            <img src="./../../assets/school/singlerow.png" v-else />
          </span>
        </h3>
        <div class="lecturerMidcontent" v-if="courseList.length > 0">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <CourseColum :dataList="courseList" v-if="showType"></CourseColum>
              <CourseRow :dataList="courseList" v-else></CourseRow>
            </van-list>
          </van-pull-refresh>
        </div>
        <div v-else class="noData">
          <img src="./../../assets/school/courseTip.png" />
          <p>讲师还未发布课程</p>
        </div>
      </div>
    </div>
    <SfBtm :mobile="mobile" v-if="!isToken && mobile"></SfBtm>
    <span class="shareTip" v-if="!isToken && mobile"
      >{{ mobile.substring(0, 3) + "****" + mobile.substring(7) }}的分享</span
    >
  </div>
</template>
<script>
import CourseColum from "./components/courseColumn.vue";
import CourseRow from "./components/courseRow.vue";
import { ImagePreview } from "vant";
import SfBtm from "./components/sfBtm.vue";
export default {
  data() {
    return {
      isIosx: false,
      lecturerUrl: "school/index/lecturer/detail",
      courseUrl: "school/index/courses",
      id: 0,
      isToken: false,
      data: {},
      courseList: [],
      showType: true,
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      pageSize: 10,
      total: 0,
      isTitle: false,
      mobile: "",
    };
  },
  components: { CourseColum, CourseRow, SfBtm },
  mounted() {
    this.isIosx = this.isIphoneX();
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    }
    if (sessionStorage.getItem("token")) {
      this.isToken = true;
      this.lecturerUrl = "school/member/lecturer/detail";
      this.courseUrl = "school/member/courses";
      this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
      this.getMobile();
    } else {
      this.isToken = false;
      this.courseUrl = "school/index/courses";
      this.lecturerUrl = "school/index/lecturer/detail";
      if (this.$route.query.mobile) {
        this.mobile = this.$route.query.mobile;
        sessionStorage.setItem("mobile", this.mobile);
      } else {
        this.mobile = sessionStorage.getItem("mobile");
      }
    }
    this.getData();
    this.getcourseData();
    window.addEventListener("scroll", this.scrollPage);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollPage);
  },
  methods: {
    scrollPage(e) {
      if (
        e.srcElement.scrollingElement &&
        e.srcElement.scrollingElement.scrollTop
      ) {
        let top = e.srcElement.scrollingElement.scrollTop; // 获取页面滚动高度
        if (top > 200) {
          this.isTitle = true;
        } else {
          this.isTitle = false;
        }
      }
    },
    prev() {
      this.$router.go(-1);
    },
    // 获取数据
    getData() {
      this.$api
        .get(this.lecturerUrl, {
          id: this.id,
        })
        .then((res) => {
          this.data = res;
        });
    },
    getcourseData() {
      this.$api
        .get(this.courseUrl, {
          lecturer_id: this.id,
          page: this.page, //类型：Number  必有字段  备注：1
          pageSize: this.pageSize, //类型：Number  必有字段  备注：10
        })
        .then((res) => {
          this.total = res.total;
          this.courseList = this.courseList.concat(res.list);
          this.refreshing = false;
          this.loading = false;
          if (this.courseList.length >= res.total) {
            // 数据全部加载完成
            this.finished = true;
          } else {
            this.finished = false;
          }
        });
    },
    // 下拉刷新
    onRefresh() {
      this.page = 1;
      this.courseList = [];
      this.getcourseData();
    },
    // 上拉加载
    onLoad() {
      this.page++;
      this.getcourseData();
    },
    changeShowType() {
      this.showType = !this.showType;
    },
    // 取消关注
    cancelConcern() {
      this.$dialog
        .confirm({
          title: "取消关注",
          message: "确认取消关注该讲师？",
          width: "280px",
          confirmButtonColor: "#4E7DF7",
          cancelButtonColor: "#EDF2FE",
          confirmButtonText: "我再想想",
          cancelButtonText: "取消关注",
          theme: "round-button",
        })
        .catch(() => {
          this.$api
            .post("school/member/cancel/fans", {
              lecturer_id: this.id,
            })
            .then((res) => {
              this.$toast("取消成功！");
              this.getData();
            });
        });
    },
    // 关注
    concern() {
      this.$api
        .post("school/member/add/fans", {
          lecturer_id: this.id,
        })
        .then((res) => {
          this.data.is_fans = true;
          this.$toast("关注成功！");
        });
    },
    // 获取会员手机号
    getMobile() {
      this.$api.get("school/member/share/mobile").then((res) => {
        this.mobile = res.mobile;
      });
    },
    // 分享
    share() {
      this.$api.post("school/index/business/school/get/share").then((res) => {
        let title = res.small_title;
        let bigTitle = res.big_title;
        let thumb = res.image;
        let url = `${location.href}&mobile=${this.mobile}`;
        let paramAndroid = [bigTitle, title, url, thumb];
        let paramIos = [title, bigTitle, url, thumb];
        this.params(paramIos, JSON.stringify(paramAndroid), "toShare");
      });
    },
    // 头像预览
    imagePreview(head_pic) {
      ImagePreview([head_pic]);
    },
  },
};
</script>

<style>
.lecturer {
  height: 100%;
  background-color: #f7f8fc;
}
.lecturerNav {
  color: #404247;
  height: 22px;
  padding-top: 38px;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 11px;
  background-color: #f7f8fc;
  /* display: flex;
  justify-content: space-between;
  align-items: center; */
  position: relative;
}
.lecturerNav .navLeft {
  width: 24px;
  height: 24px;
  position: absolute;
  left: 16px;
}
.navTitle {
  font-size: 17px;
  font-weight: 700;
  color: #404247;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.lecturerNav .navRight {
  width: 40px;
  height: 31px;
  position: absolute;
  right: 16px;
  bottom: 5px;
}
.lecturerTop {
  /* height: 213px; */
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 24px;
}
.lecturerTop img {
  width: 72px;
  height: 72px;
  border: 4px solid #ffffff;
  border-radius: 50%;
  margin-top: 16px;
  background-color: #ffffff;
}
.lecturerTop h3 {
  font-size: 16px;
  font-weight: 600;
  color: #404247;
  margin: 12px 16px 0;
}
.lecturerTop p {
  font-size: 12px;
  font-weight: 400;
  color: #9ca1ad;
  margin: 8px 16px 0;
}
.lecturerTop span {
  width: 80px;
  height: 30px;
  line-height: 30px;
  background: #ffffff;
  border-radius: 16px;
  text-align: center;
  font-size: 13px;
  font-weight: 500;
  color: #4e7df7;
  margin-top: 12px;
}

.isShowTitle {
  background-color: #ffffff;
}

.lecturerMid {
  padding: 24px 16px;
  background: #ffffff;
  border-radius: 16px 16px 0px 0px;
}
.lecturerMid > h3 {
  margin: 0;
  display: flex;
  justify-content: space-between;
  font-size: 15px;
  font-weight: 700;
  color: #333333;
}
.lecturerMid > h3 img {
  width: 16px;
  height: 16px;
}
.lecturerMidcontent {
  margin-top: 16px;
}

.lecturerMid .noData {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.noData img {
  width: 235px;
  height: 235px;
}
.noData p {
  margin-top: 24px;
  font-size: 14px;
  color: #9ca1ad;
}

.van-dialog__confirm,
.van-dialog__cancel {
  margin: 0 8px;
  border-radius: 18px;
}
.van-dialog__cancel {
  color: #4e7df7 !important;
}

.isIosx .lecturerNav {
  padding-top: 44px;
}
.noAppNav .lecturerNav {
  padding-top: 15px !important;
}
.noAppNav .lecturerContent {
  padding-bottom: 60px;
}
.shareTip {
  position: fixed;
  top: 7px;
  right: 0;
  padding: 8px 16px 8px 24px;
  background: rgba(14, 14, 14, 0.36);
  border-radius: 18px 0px 0px 18px;
  font-size: 15px;
  font-weight: 500;
  color: #ffffff;
  z-index: 999;
}
</style>
